import { render, staticRenderFns } from "./SetDefaultProperty.vue?vue&type=template&id=4a1e12fa&scoped=true"
import script from "./SetDefaultProperty.vue?vue&type=script&lang=js"
export * from "./SetDefaultProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1e12fa",
  null
  
)

export default component.exports